import { useEffect, useState } from "react";
import { notificationService } from "@/services/notification.service";
import { Notification } from "@/types/notification.type";

export function useActionNotifications() {
  const [actions, setActions] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchActions = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await notificationService.getActionNotifications();
      setActions(data);
    } catch (err: any) {
      setError("Failed to load action notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActions();
  }, []);

  const handleAccept = async (action: Notification) => {
    await notificationService.handleAccept(action.id);
    await fetchActions();
  };

  const handleDecline = async (action: Notification) => {
    await notificationService.handleDecline(action.id);
    await fetchActions();
  };

  return {
    actions,
    loading,
    error,
    handleAccept,
    handleDecline,
    refetch: fetchActions,
  };
}
